<template>
  <div class="home-page">
    <AppHeader 
      class="app-header--dark"
    />
    <v-container class="white--text home-page_preview">
      <v-layout row>
        <v-flex
          md12
          class="home-page_preview-inner"
        >
          <h1 class="home-page_preview-title">
            Track Your
            <br>
            Charity Activity
          </h1>
          <span class="subheading">Make it count</span>
        </v-flex>
      </v-layout>
    </v-container>
    <div class="home-page_parallax" />
    <router-link
      to="registration"
    >
      <BottomPanel
        button-text="GET STARTED"
      />
    </router-link>
  </div>
</template>

<script>
  import AppHeader from '../components/AppHeader';
  import BottomPanel from "../components/BottomPanel";

  export default {
    name: "Home",
    components: {
      AppHeader,
      BottomPanel
    },
  }
</script>

<style scoped>
  .home-page {
    position: relative;
    box-sizing: border-box;
    background-color: #212121 !important;
  }

  .home-page_preview {
    height: calc(50vh - 100px);
    box-sizing: border-box;
    display: flex;
    padding-top: 5vh;
    padding-left: 50px;
    padding-right: 50px;
  }

  .home-page_preview-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .home-page_parallax {
    height: 50vh;
    background-image: url('../assets/home-preview.jpg');
    background-size: cover;
    background-position: bottom center;
  }

  .home-page_preview-title {
    position: relative;
    font-weight: bold;
    padding-bottom: 10px;
    margin-bottom: 10px;
    font-size: 30px;
    line-height: 35px;
  }

  .home-page_preview-title::after {
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    content: '';
    width: 50px;
    height: 1px;
    background-color: #fff;
  }
</style>
